import React, { useEffect, useState } from "react";
import {
  DataGrid,
  GridColDef,
  GridToolbar,
} from "@mui/x-data-grid";
import axios from "axios";
import HOST_URL from "../../utils/Url";
import Card from "@mui/material/Card";
import {
  Box,
  Button,
  Divider,
  Modal,
  Stack,
  IconButton,
  Typography,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import Switch from "@mui/material/Switch";
import { useNavigate, useLocation } from "react-router-dom";
import Chip from "@mui/material/Chip";
import { useTranslation } from "react-i18next";
import Paper from "@mui/material/Paper";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import { toast } from "react-toastify";
import ToastApp from "../../ToastApp";
import DeleteIcon from "@mui/icons-material/Delete";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import CircularProgress from "@mui/material/CircularProgress";
import api from "../../utils/Url";
import CloseIcon from "@mui/icons-material/Close";
import { faL } from "@fortawesome/free-solid-svg-icons";


interface MenuPermission {
  isAdd: boolean;
  isEdit: boolean;
  isPrint: boolean;
  isDel: boolean;
}

export default function EmployeeMaster() {
  const [zones, setZones] = useState([]);
  const [columns, setColumns] = useState<any>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isScanLoading, setIsScanLoading] = useState(false);
  const location = useLocation();
  const [permissionData, setPermissionData] = useState<MenuPermission>({
    isAdd: false,
    isEdit: false,
    isPrint: false,
    isDel: false,
  });

  let navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    const dataString = localStorage.getItem("userdata");
    if (dataString) {
      const data = JSON.parse(dataString);
      if (data && data.length > 0) {
        const userPermissionData = data[0]?.userPermission;
        if (userPermissionData && userPermissionData.length > 0) {
          const menudata = userPermissionData[0]?.parentMenu;
          for (let index = 0; index < menudata.length; index++) {
            const childMenudata = menudata[index]?.childMenu;
            const pathrow = childMenudata.find(
              (x: any) => x.path === location.pathname
            );
            console.log("data", pathrow);
            if (pathrow) {
              setPermissionData(pathrow);
              fetchZonesData();
            }
          }
        }
      }
    }
  }, []);
  // }, [isLoading]);
  const routeChangeAdd = () => {
    let path = `/Employee/EmployeeAdd`;
    navigate(path);
  };

  const handleSwitchChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    value: any
  ) => {
    console.log(value)
    const updatedStatus = event.target.checked ? "Active" : "InActive";
    const collectData = {
      empid: value.id,
      empName: value.empName,
      empCode: value.empCode,
      userID: value.userID,
      sortOrder: value.sortOrder,
      empPerAddress: value.empPerAddress,
      empFatherName: value.empFatherName,
      empspauseName: value.empspauseName,
      empMotherName: value.empMotherName,
      empMobileNo: value.empMobileNo,
      empStatus: updatedStatus,
      empPanNumber: value.empPanNumber,
      empAddharNo: value.empAddharNo,
      empDob: value.empDob,
      empJoiningDate: value.JoinindDate,
      empretirementDate: value.empretirementDate,
      empPincode: value.empPincode,
      roleId: value.roleId,
      // imageFile: value.imageFile,
      // signatureFile: value.signatureFile,
      email: value.email,
      dlno: value.dlno,
      gender: value.gender,
      empLocalAddress: value.empLocalAddress,
      empDesignationId: value.empDesignationId,
      empDeptId: value.empDeptId,
      empStateId: value.StateId,
      empCountryID: value.empCountryID,
      empCityId: value.empCityId,
      user_ID: value.user_ID,
      // ...value,
      // empStatus: updatedStatus,
    };
    api
      .post(`EmpMaster/AddUpdateEmpmaster`, collectData)
      .then((response) => {
        if (response.data.isSuccess) {
          toast.success(response.data.mesg);
          fetchZonesData();
        } else {
          toast.error(response.data.mesg);
        }
      });
  };
  const routeChangeEdit = (row: any) => {
    console.log("row " + row);

    let path = `/Employee/EmployeeEdit`;
    navigate(path, {
      state: row,
    });
  };



  let delete_id = "";

  const accept = () => {
    const collectData = {
      empid: delete_id,
    };

    api
      .delete(`EmpMaster/DeleteEmpmaster`, { data: collectData })
      .then((response) => {
        if (response.data.isSuccess) {
          toast.success(response.data.mesg);
        } else {
          toast.error(response.data.mesg);
        }
        fetchZonesData();
      });
  };

  const reject = () => {
    // toast.warn({summary: 'Rejected', detail: 'You have rejected', life: 3000 });
    toast.warn("Rejected: You have rejected", { autoClose: 3000 });
  };

  const handledeleteClick = (del_id: any) => {
    // console.log(del_id + " del_id ");
    delete_id = del_id;
    confirmDialog({
      message: "Do you want to delete this record ?",
      header: "Delete Confirmation",
      icon: "pi pi-info-circle",
      acceptClassName: "p=-button-danger",
      accept,
      reject,
    });
  };

  const handleBiometricScan = async (empCode: any) => {
    setIsScanLoading(true);
    try {
      const res = await axios.get(`http://localhost:8080/api/Aratek/ExtrAratek?UsrCodP=${empCode}`);
      if (res.data.isSuccess && res.data.message !== "ok") {
        toast.success(res.data.message);
        setIsScanLoading(false);
      } else if (res.data.message === "ok") {
        setIsScanLoading(false);
        toast.error("No Fingerprint device found!");
      } else {
        setIsScanLoading(false);
        toast.error(res.data.message);
      }
      fetchZonesData();
    } catch (error) {
      toast.error("Error fetching Api")
      setIsScanLoading(false);
    }
  }

  const fetchZonesData = async () => {
    try {
      const collectData = {
        mem_cd: "",
        mem_ctgry: "",
        // mem_ctgry:"CC",
        mem_inst: "",
        mem_dept: "",
        mem_degree: "",
        image: false

      };
      console.log("collectData", collectData)
      const response = await api.post(
        `Member/Getm_member`,
        collectData
      );
      console.log("result", response.data.data)
      const data = response.data.data;
      const zonesWithIds = data.map((emp: any, index: any) => ({
        ...emp,
        serialNo: index + 1,
        id: emp.mem_cd,
        empName: [emp.mem_firstnm, emp.mem_midnm, emp.mem_lstnm].filter(Boolean).join(" "),
      }));


      setZones(zonesWithIds);
      setIsLoading(false);

      if (data.length > 0) {
        const columns: GridColDef[] = [
          {
            field: "serialNo",
            headerName: t("text.SrNo"),
            flex: 0.2,
            minWidth: 50,
            headerClassName: "MuiDataGrid-colCell",
          },
          {
            field: "id",
            headerName: t("text.EmpCode"),
            flex: 1,
            minWidth: 120,
            headerClassName: "MuiDataGrid-colCell",
          },
          {
            field: "empName",
            headerName: t("text.EmpName"),
            flex: 1,
            minWidth: 140,
            headerClassName: "MuiDataGrid-colCell",
          },
          {
            field: "mem_prmntphone",
            headerName: "Mobile No.",
            flex: 1,
            minWidth: 100,
            headerClassName: "MuiDataGrid-colCell",
          },
          {
            field: "mem_email",
            headerName: "Email",
            flex: 1,
            minWidth: 180,
            headerClassName: "MuiDataGrid-colCell",
          },
          {
            field: "mem_prmntadd1",
            headerName: "Address",
            flex: 1.5,
            minWidth: 200,
            headerClassName: "MuiDataGrid-colCell",
          },
          {
            field: "subject",
            headerName: "Subject",
            flex: 1,
            minWidth: 80,  // Apply a minimum width
            headerClassName: "MuiDataGrid-colCell",
          },
          {
            field: "biometric",
            headerName: t("text.BioScan"),
            flex: 1,
            minWidth: 100,
            headerClassName: "MuiDataGrid-colCell",
            renderCell: (params) => [
              <Stack direction="row" spacing={1}>
                <Button
                  type="button"
                  fullWidth
                  style={{
                    backgroundColor: "#059669",
                    color: "white",
                    marginTop: "10px",
                  }}
                  onClick={() => {
                    handleBiometricScan(params.row.id);
                  }}
                >
                  {t("text.Scan")}
                </Button>
              </Stack>,
            ],
          },
          {
            field: "thumStatus",
            headerName: "Status",
            flex: 1,
            minWidth: 60,
            headerClassName: "MuiDataGrid-colCell",
            renderCell: (params) => [
              params.row.thumStatus == null
                ? "false"
                : params.row.thumStatus == "true"
                  ? "true"
                  : "false",
            ],
          },
          {
            field: "mem_status",
            headerName: t("text.EmpStatus"),
            flex: 1,
            minWidth: 120,
            headerClassName: "MuiDataGrid-colCell",
            renderCell: (params) => [
              <Stack direction="row" spacing={1}>
                {params.row.mem_status === "A" ? (
                  <Chip
                    label={t("Active")}
                    color="success"
                    style={{ fontSize: "14px" }}
                  />
                ) : (
                  <Chip
                    label={"InActive"}
                    color="error"
                    style={{ fontSize: "14px" }}
                  />
                )}
              </Stack>,
            ],
          },
        ];

        setColumns(columns as any);
      }

    } catch (error) {
      console.error("Error fetching data:", error);
      // setLoading(false);
    }
  };

  const adjustedColumns = columns.map((column: any) => ({
    ...column,
  }));


  return (
    <>
      <Card
        style={{
          width: "100%",
          // height: "100%",
          backgroundColor: "#E9FDEE",
          // border: ".5px solid #FF7722 ",
          marginTop: "3vh"
        }}
      >
        <Paper
          sx={{
            width: "100%",
            overflow: "hidden",
            "& .MuiDataGrid-colCell": {
              backgroundColor: "#2B4593",
              color: "#fff",
              fontSize: 17,
              fontWeight: 900
            },
          }}
          style={{ padding: "10px", }}
        >
          <ConfirmDialog />

          <Typography
            gutterBottom
            variant="h5"
            component="div"
            sx={{ padding: "20px" }}
            align="left"
          >
            {t("text.EmpMaster")}
          </Typography>
          <Divider />

          {/* <Box height={10} />  */}

          <Stack direction="row" spacing={2} classes="my-2 mb-2">
            {/*permissionData?.isAdd == true && ( */}
            {/* <Button
              onClick={routeChangeAdd}
              variant="contained"
              endIcon={<AddCircleIcon />}
              size="large"
            >
              {t("text.Add")}
            </Button> */}
            {/*)} */}

            {/*{permissionData?.isPrint == true ? (
              <Button variant="contained" endIcon={<PrintIcon />} size="large">
                {t("text.print")}
              </Button>
            ) : (
              ""
            )} */}
          </Stack>

          {isLoading ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <CircularProgress />
            </div>
          ) : (
            <Box>
              <br />
              <div
                style={{
                  width: '100%',
                  backgroundColor: '#FFFFFF',
                  overflowX: 'auto',  // Allow horizontal scrolling when needed
                }}
              >
                <DataGrid
                  rows={zones}
                  columns={adjustedColumns}
                  autoHeight
                  slots={{
                    toolbar: GridToolbar,
                  }}
                  rowSpacingType="border"
                  pagination={true}
                  pageSizeOptions={[5, 10, 25, 50, 100].map((size) => ({
                    value: size,
                    label: `${size}`,
                  }))}
                  initialState={{
                    pagination: { paginationModel: { pageSize: 5 } },
                  }}
                  slotProps={{
                    toolbar: {
                      showQuickFilter: true,
                    },
                  }}
                  getRowHeight={() => 'auto'} // Auto row height
                  sx={{
                    '& .MuiDataGrid-cell': {
                      whiteSpace: 'normal', // Enable text wrap
                      wordBreak: 'break-word',
                      lineHeight: '1.5rem',
                      padding: '8px',
                    },
                    '& .MuiDataGrid-columnHeaders': {
                      minHeight: '40px !important',
                      maxHeight: '40px !important',
                    },
                    '& .MuiDataGrid-columnHeaderTitle': {
                      fontSize: '14px',
                      fontWeight: 'bold',
                      whiteSpace: 'normal',
                      lineHeight: '1.3rem',
                    },
                    // Make the grid responsive without breaking layout
                    '& .MuiDataGrid-columnsContainer': {
                      display: 'flex',
                      flexWrap: 'wrap',  // Allow wrapping for columns if needed
                    },
                    '& .MuiDataGrid-columnHeader': {
                      minWidth: '100px', // Minimum width for headers to prevent content overflow
                    },
                  }}
                  columnBuffer={adjustedColumns.length}
                />
              </div>


            </Box>)}

          {/* <Modal open={isScanLoading}>
            <Box
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: 300,
                bgcolor: "background.paper",
                boxShadow: 24,
                p: 4,
                borderRadius: 2,
                textAlign: "center",
              }}
            >
              <Typography variant="h6" gutterBottom>
                Scan Your Fingerprint
              </Typography>
              <Typography variant="body2" gutterBottom>
                Please place your finger on the scanner to proceed.
              </Typography>
              <CircularProgress size={24} color="inherit" />
            </Box>
          </Modal> */}
          <Modal open={isScanLoading} onClose={() => setIsScanLoading(false)}>
            <Box
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: 300,
                bgcolor: "background.paper",
                boxShadow: 24,
                p: 4,
                borderRadius: 2,
                textAlign: "center",
              }}
            >
              {/* Close Button */}
              <IconButton
                onClick={() => setIsScanLoading(false)}
                sx={{ position: "absolute", top: 8, right: 8 }}
                aria-label="close"
              >
                <CloseIcon />
              </IconButton>

              <Typography variant="h6" gutterBottom>
                Scan Your Fingerprint
              </Typography>
              <Typography variant="body2" gutterBottom>
                Please place your finger on the scanner to proceed.
              </Typography>
              <CircularProgress size={24} color="inherit" />
            </Box>
          </Modal>
        </Paper>
      </Card>
      <ToastApp />

    </>
  );
}
